/*!
 * Stimpack Post List
 *
 * @version : 0.6
 * @author  : Matthias Courville
 */

import { spBase64Decode } from '../utilities/utilities';

(function($){

    /* ---------------------------------------------------------------------- */
    /* Init
    /* ---------------------------------------------------------------------- */

    var spItemList = function(el, options)
    {
        var _el = $(el);

        this.defaultOptions = {
            'type'          : '',
            'groupBy'       : false,
            'groupType'     : false,
            'columns'       : false,
            'pagination'    : false,
            'scroll'        : false
        };

        this.o = $.extend({}, this.defaultOptions, options);

        this.el = {
            root       : _el,
            itemsContainer  : _el.find('.sp-item-list-items'),
            lightbox        : _el.find('.sp-item-list-lightbox')
        };

        this.init();
        this.refresh();

        return this;
    };

    spItemList.prototype.init = function()
    {
        var _t = this;

        // ------------------------------------------------------------------ //

        this.breakpoints = [];

        $.each(STIMPACK.breakpoints, function(name, width) {
            _t.breakpoints.push({name: name, width: width});
        });

        this.breakpoints.sort(function (a, b) {
            return a.width > b.width ? 1 : -1;
        });


        // ------------------------------------------------------------------ //

        if ('accordion' === this.o.type || (this.o.groupBy && 'accordion' === this.o.groupType))
        {
            this.initAccordion();
        }

        // ------------------------------------------------------------------ //

        // Scroll
        /*if (this.o.scroll)
        {
            this.initScroll();
        }*/

        // Type
        /*if ('slider' === this.o.type)
        {
            this.initSlider();
        }*/

        // Pagination
        if (this.o.pagination)
        {
            this.initPagination();
        }

        // Modal
        this.initModal();

        // ------------------------------------------------------------------ //

        this.resizeTimeout = 0;

        $(window).resize(function() {
            clearTimeout(_t.resizeTimeout);
            _t.resizeTimeout = setTimeout(function() {
                _t.refresh();
            }, 100);
        });

        this.setStatus('initiated');
    };

    spItemList.prototype.initAccordion = function()
    {
        console.log('initAccordion');
        this.accordion = this.el.root.spAccordion();
    }

    /* ---------------------------------------------------------------------- */
    /* Refresh
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.refresh = function()
    {
        this.refreshRows();
        this.refreshPagination();
    };

    /* ---------------------------------------------------------------------- */
    /* Rows / Columns
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.getColumns = function()
    {
        var _t = this;

        if (this.o.columns)
        {
            var windowWidth = $(window).width();

            // TODO: check if changed, skip
            $.each(this.breakpoints, function(i, b) {

                if (windowWidth > b.width && typeof _t.o.columns[b.name] != 'undefined' && _t.o.columns[b.name].width > 0)
                {
                    _t.columns = _t.o.columns[b.name];
                }
            });
        }

        return this.columns;
    };

    spItemList.prototype.refreshRows = function()
    {
        var _t = this,
            columns = this.getColumns();

        if (columns)
        {
            this.el.itemsContainer.each(function() {

                var container = $(this),
                    items = container.find('.item');

                container.append(items);
                container.find('> .row').remove();

                if (columns.count > 0)
                {
                    for (var i = 0; i < items.length; i += columns.count)
                    {
                        items.slice(i, i + columns.count).wrapAll('<div class="row"></div>');
                    }
                }
                else
                {
                    items.wrapAll('<div class="row"></div>');
                }
            });
        }
    };



    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.setStatus = function(status)
    {
        this.status = status;
        this.el.root.attr('data-status', status);
    };

    spItemList.prototype.getStatus = function()
    {
        return this.status;
    };

    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.getPosts = function(options)
    {
        var _t = this;

        if ('loading' === this.getStatus())
        {
            return;
        }

        this.setStatus('loading');

        $.ajax({
            url		   : STIMPACK.ajaxUrl,
            type	   : 'post',
            data	   : {
                action      : 'stimpack_item_list_get',
                ids         : options.ids ? options.ids : null,
                page        : options.page ? options.page : null,
                template    : options.template ? options.template : null,
                options     : JSON.stringify(this.o)
            },
            dataType   : 'json',
            success: function(data) {

                if (data.debug)
                {
                    console.log(data);
                }

                _t.setStatus('success');

                if (options.onSuccess)
                {
                    options.onSuccess(data);
                }

                _t.refresh();
            },
            error: function(data) {
                _t.setStatus('error');
            },
            timeout: 10000
        });
    };

    /* ---------------------------------------------------------------------- */
    /* Pagination
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.insertItems = function(items)
    {
        var _t = this;

        $.each(items, function(index, item) {
            _t.el.itemsContainer.append(item.html);
        });

        this.refresh();
    };

    /* ---------------------------------------------------------------------- */
    /* Pagination
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.initPagination = function(html)
    {
        var _t = this;

        this.currentPage = this.currentPage || 1;

        this.el.paginationButton = this.el.root.find('.sp-item-list-pagination-ajax .sp-item-list-pagination-button');

        this.el.paginationButton.on('click', function(e) {

            e.preventDefault();
            _t.currentPage++;

            _t.getPosts({
                page        : _t.currentPage,
                onSuccess   : function(data) {
                    _t.insertItems(data.posts);
                }
            });
        });
    };

    spItemList.prototype.refreshPagination = function()
    {
        if (this.currentPage >= this.o.max_num_pages)
        {
            this.el.paginationButton
                .addClass('disabled')
                .text('End...');
        }
    };

    /* ---------------------------------------------------------------------- */
    /* Modal
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.initModal = function()
    {
        var _t = this;

        this.el.modal = this.el.root.find('.sp-item-list-modal');

        if (this.el.modal.length > 0)
        {
            this.el.modalItemsContainer = this.el.modal.find('.sp-item-list-modal-items');

            this.el.itemsContainer.on('click', '.sp-item-list-modal-trigger, a:not(.sp-item-list-skip-modal)', function(e) {

                e.preventDefault();

                var trigger = $(this),
                    itemId = trigger.closest('.item').data('id'),
                    item = _t.el.modalItemsContainer.find('.item[data-id="' + itemId + '"]');

                if (item.length > 0)
                {
                    _t.showModal(item);
                }
                else
                {
                    _t.getPosts({
                        ids         : [itemId],
                        template    : 'modal',
                        onSuccess   : function(data) {

                            $.each(data.posts, function(index, post) {
                                _t.el.modalItemsContainer.append(post.html);
                            });

                            _t.showModal(itemId);
                        }
                    });
                }
            });
        }
    };

    spItemList.prototype.showModal = function(item)
    {
        if ($.isNumeric(item))
        {
            item = this.el.modalItemsContainer.find('> .item[data-id="' + item + '"]');
        }

        this.el.modalItemsContainer.find('> .active').removeClass('active');
        item.addClass('active');

        this.el.modal.modal('show');
    };

    /* ---------------------------------------------------------------------- */
    /* Slider
    /* ---------------------------------------------------------------------- */

    /*spItemList.prototype.initSlider = function()
    {
        var sliderOptions = this.o.slider_options || {};

        this.el.slider = this.el.itemsContainer;

        this.el.slider.not('.slick-initialized').slick($.extend({}, {
            dots            : true,
            appendDots      : this.el.slider,
            arrows          : false
        }, sliderOptions));
    };*/

    /* ---------------------------------------------------------------------- */
    /* Scroll
    /* ---------------------------------------------------------------------- */

    spItemList.prototype.updateScroll = function(html)
    {
        var _t = this,
            scrollCount = true === this.o.scroll ? this.o.scroll : 3,
            height = 0;

        this.el.itemsContainer.find('.item').slice(0, scrollCount).each(function(index) {

            var el = ((index + 1) == scrollCount) ? _t.el.itemsContainer.find('.item:last-child') : $(this);

            height += el.outerHeight(true);
        });

        this.el.itemsContainer.css('height', height);
    };

    /*spItemList.prototype.initScroll = function(html)
    {
        var _t = this;

        if (typeof PerfectScrollbar != 'undefined')
        {
            this.scrollbar = new PerfectScrollbar(this.el.root.find('.sp-item-list-items')[0], {
                wheelSpeed: 2,
                wheelPropagation: false,
                minScrollbarLength: 20,
                suppressScrollX: true
            });

            setTimeout(function() {
                _t.scrollbar.update();
            }, 100);
        }

        $(window).resize(function() {
            _t.updateScroll();
        });
    };*/

    /* ---------------------------------------------------------------------- */
    /* Factory
    /* ---------------------------------------------------------------------- */

    $.fn.spItemList = function(options)
    {
        return this.each(function() {

            var _options = $(this).data('sp-item-list'),
                options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});

            $(this).attr('data-sp-item-list', true);

            if (typeof options == 'object' || typeof options == 'undefined')
            {
                this.spItemList = new spItemList(this, options);
            }
        });
    };

    /* ---------------------------------------------------------------------- */
    /*
    /* ---------------------------------------------------------------------- */
    $('[data-sp-item-list]').spItemList();

})(jQuery);
